/* Walk-In Chicken Coop — locked-step slide navigation over the real product photo.
   No continuous scroll-linked motion: every input (wheel, key, swipe, button, chip)
   advances exactly one step, and input is ignored while a transition is in flight.
   Wheel/touch events call preventDefault() so the underlying theme page can't also
   scroll while this component is active. */

(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var TRANSITION_MS = reduceMotion ? 60 : 1150;

  var slides = Array.prototype.slice.call(document.querySelectorAll(".slide"));
  var chips = Array.prototype.slice.call(document.querySelectorAll(".chips button"));
  var photoLayer = document.getElementById("photo-layer");
  var prevBtn = document.getElementById("prevBtn");
  var nextBtn = document.getElementById("nextBtn");
  var stepNow = document.getElementById("stepNow");

  var idx = 0;
  var locked = false;
  var total = slides.length;

  function render() {
    slides.forEach(function (s, i) { s.classList.toggle("active", i === idx); });
    chips.forEach(function (c, i) { c.classList.toggle("active", i === idx); });
    photoLayer.className = "s" + idx;
    stepNow.textContent = idx + 1;
    prevBtn.disabled = idx === 0;
    nextBtn.disabled = idx === total - 1;
  }

  function goTo(i) {
    i = Math.max(0, Math.min(total - 1, i));
    if (i === idx || locked) return;
    idx = i;
    render();
    locked = true;
    setTimeout(function () { locked = false; }, TRANSITION_MS);
  }

  prevBtn.addEventListener("click", function () { goTo(idx - 1); });
  nextBtn.addEventListener("click", function () { goTo(idx + 1); });
  chips.forEach(function (c) {
    c.addEventListener("click", function () { goTo(parseInt(c.getAttribute("data-i"), 10)); });
  });

  // Wheel / trackpad — one step per gesture. preventDefault stops the underlying
  // theme page from also scrolling; {passive:false} is required for that to work.
  var wheelAccum = 0;
  window.addEventListener("wheel", function (e) {
    e.preventDefault();
    if (locked) return;
    wheelAccum += e.deltaY;
    if (Math.abs(wheelAccum) > 24) {
      goTo(idx + (wheelAccum > 0 ? 1 : -1));
      wheelAccum = 0;
    }
  }, { passive: false });

  // Keyboard
  window.addEventListener("keydown", function (e) {
    if (["ArrowDown", "PageDown", " "].indexOf(e.key) !== -1) { e.preventDefault(); goTo(idx + 1); }
    else if (["ArrowUp", "PageUp"].indexOf(e.key) !== -1) { e.preventDefault(); goTo(idx - 1); }
    else if (e.key === "Home") { goTo(0); }
    else if (e.key === "End") { goTo(total - 1); }
  });

  // Touch swipe — preventDefault on touchmove stops native page scroll/bounce.
  var touchStartY = null;
  window.addEventListener("touchstart", function (e) {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  window.addEventListener("touchmove", function (e) {
    e.preventDefault();
  }, { passive: false });
  window.addEventListener("touchend", function (e) {
    if (touchStartY === null) return;
    var dy = touchStartY - e.changedTouches[0].clientY;
    touchStartY = null;
    if (Math.abs(dy) > 40) goTo(idx + (dy > 0 ? 1 : -1));
  }, { passive: true });

  render();

  // Preloader — the photo is the only real asset to wait on. The CSS opacity/
  // visibility transition handles the visual fade, but relying on a
  // transitioned `visibility` to pull it out of hit-testing is unreliable
  // across browsers — force display:none once the fade completes so it can
  // never block clicks to the real page underneath.
  var pre = document.getElementById("pre");
  var preFinished = false;
  function finishLoad() {
    if (preFinished) return;
    preFinished = true;
    setTimeout(function () {
      pre.classList.add("hide");
      setTimeout(function () { pre.style.display = "none"; }, 550);
    }, 150);
  }
  if (photoLayer.complete) { finishLoad(); }
  else {
    photoLayer.addEventListener("load", finishLoad);
    photoLayer.addEventListener("error", finishLoad);
  }
  setTimeout(finishLoad, 2500);
})();
